<template>
  <div v-if="isShow" class="message-table">
    <h4>傳訊息給司機:</h4>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="select-row">
          <el-select
            v-model="form.defaultMsg"
            placeholder="請選擇"
            @change="onDefaultMsg"
            class="message-select"
          >
            <el-option
              v-for="{ message } in defaultMsgList"
              :key="message"
              :label="message"
              :value="message"
            ></el-option>
          </el-select>
          <span class="fontSize16 title-color">(預設訊息)</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7 col-sm-7">
        <textarea
          type="text"
          required="required"
          class="inputstyle fontSize14"
          placeholder="純文字...最多100個字"
          row="3"
          v-model="form.msg"
          maxlength="100"
        />
      </div>
      <div class="col-md-5 col-sm-5">
        <button class="btn btn-primary" @click="onSendMsg" :loading="isLoading">
          傳送訊息
        </button>
        <el-checkbox v-model="form.requireDriverResponse">
          請司機回覆「是」「否」
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { reqDefaultMsg } from '@/api/driverMsg'
import { Notification } from 'element-ui'
import Message from '@/assets/js/libs/Message'
import { cookies } from '@/utils/cookies'

const message = new Message()

export default {
  name: 'MessageTable',
  data() {
    return {
      isLoading: false,
      form: {
        defaultMsg: null,
        msg: null,
        requireDriverResponse: false,
      },
      defaultMsgList: [],
    }
  },
  computed: {
    ...mapState('reserveModal', {
      vx_driverInfo: 'driverInfo',
      vx_billInfo: 'billInfo',
    }),
    driverCallNumber() {
      return Object.keys(this.vx_driverInfo).length
        ? this.vx_driverInfo.callNumber
        : ''
    },
    isShow() {
      return this.vx_billInfo.result !== 2
    },
  },
  methods: {
    onDefaultMsg(defaultMsg) {
      this.form.msg = defaultMsg
    },
    async onSendMsg() {
      if (!this.form.msg) {
        Notification({
          type: 'warning',
          message: '請輸入傳送的訊息',
        })
        return
      }

      if (!this.driverCallNumber) {
        Notification({
          type: 'warning',
          message: '目前沒有司機接單，無法發送訊息',
        })
        return
      }

      try {
        this.isLoading = true
        const payload = {
          announcer: cookies.get('GladName'),
          teamCode: cookies.get('GladTeamCode'),
          callNumber: this.driverCallNumber,
          content: this.form.msg,
          reference: '預約單',
          black: null,
          is_important: false,
          require_driver_response: this.form.requireDriverResponse,
          services: null,
          status: null,
        }

        console.log('發送payload:', payload)

        const { success } = await message.pushDriverMessage(payload, 'one')

        if (success) {
          this.form.msg = null
          this.form.defaultMsg = null
          Notification({
            type: 'success',
            message: '傳送成功',
          })
        } else {
          throw new Error('傳送失敗')
        }
      } catch (e) {
        console.error('發送錯誤:', e)
        Notification({
          type: 'error',
          message: '傳送失敗',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  async mounted() {
    try {
      const { result } = await reqDefaultMsg()
      if (!result) {
        Notification({
          type: 'error',
          message: '找不到預設的司機訊息',
        })
        this.defaultMsgList = []
      } else {
        this.defaultMsgList = JSON.parse(result)
      }
    } catch (e) {
      console.error(e)
      Notification({
        type: 'error',
        message: '獲取預設訊息失敗',
      })
    }
  },
}
</script>

<style scoped>
:root {
  --select-width: 400px;
}

.message-table .select-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.message-table .message-select {
  width: var(--select-width);
  margin-right: 10px;
}

.message-table .el-select-dropdown {
  min-width: var(--select-width);
}

.message-table .el-select-dropdown__item {
  white-space: normal;
  height: auto;
  line-height: 1.5;
  padding: 8px 20px;
  word-break: break-word;
}

.message-table .inputstyle {
  border: 1px solid #dcdfe6;
  width: 100%;
  box-sizing: border-box;
}

.message-table .btn-primary {
  margin-right: 15px;
}

.message-table .el-checkbox {
  font-size: 12px;
  color: #666;
}

.message-table .fontSize20 {
  font-size: 20px;
}

.message-table .fontSize14 {
  font-size: 14px;
}

.message-table .title-color {
  color: #333;
}

.message-table .row {
  margin-bottom: 15px;
}

.message-table .col-md-5 {
  padding-left: 0;
}

.bold-text {
  font-weight: bold;
}

.select-row {
  display: flex;
  align-items: center;
}

.message-select {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/reserveModal/MessageTable.vue